export default function getResource(label) {
    const resources = {
        viewMore: 'View more',
        viewLess: 'View less'
    };
    return resources[label];
}
